import {put, call, select, takeLatest} from 'redux-saga/effects';
import searchApi from '../api/search.api';
import * as ActionTypes from '../actions/types.action';
import {getBearerHeader} from '../helpers/api.helper';
import {processedGQLSearchResults} from '../helpers/data.helper';
import {waitFor} from '../helpers/saga.helper';
import {DEFAULT_BRANCH} from '../constants/constants';

function* halalBestSellers(action) {
  try {
    const getAuth = state => state.auth;
    const getBranchId = state => state.branch;
    let storeToken = yield select(getAuth);
    if (!storeToken) {
      storeToken = yield waitFor(getAuth, 3, 300);
    }
    const headers = getBearerHeader(null, storeToken);
    let branch = action.branch || (yield select(getBranchId));
    if (!branch) {
      branch = yield waitFor(getBranchId, 5, 300);
    }
    const params = {
      first: action.itemIds,
      b: branch || DEFAULT_BRANCH,
      page: 0,
      size: action.itemIds.length,
    };
    const result = yield call(searchApi.search, params, headers);
    if (!result || result.errors) {
      yield put({
        type: ActionTypes.GET_HALAL_BEST_SELLERS_FAILED,
        message: result && result.errors && result.errors[0],
      });
      return;
    }
    const searchId =
      result.data &&
      result.data.searchProducts &&
      result.data.searchProducts.searchId;
    yield put({
      type: ActionTypes.GET_HALAL_BEST_SELLERS_SUCCESS,
      items:
        (result.data &&
          result.data.searchProducts &&
          result.data.searchProducts.results &&
          processedGQLSearchResults(
            result.data.searchProducts.results,
            searchId
          )) ||
        [],
    });
  } catch (e) {
    yield put({
      type: ActionTypes.GET_HALAL_BEST_SELLERS_FAILED,
      message: e.message,
    });
  }
}

export default function* halalBestSellersYield() {
  yield takeLatest(
    ActionTypes.GET_HALAL_BEST_SELLERS_REQUESTED,
    halalBestSellers
  );
}
